<template>
  <div class="min-h-screen bg-gray-50 dark:bg-gray-900">
    <HeaderDefault />

    <!-- Profile Section -->
    <section class="py-12">
      <div class="max-w-screen-lg mx-auto px-4">
        <div v-if="!pending && userData">
          <ProfilePage :profile="userData.data.attributes"></ProfilePage>
        </div>

        <!-- Loading State -->
        <div
          v-else-if="pending"
          class="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8 animate-pulse"
        >
          <div class="flex items-start gap-6 mb-8">
            <div
              class="w-24 h-24 rounded-full bg-gray-200 dark:bg-gray-700"
            ></div>
            <div class="space-y-3 flex-1">
              <div class="h-8 bg-gray-200 dark:bg-gray-700 rounded w-3/4"></div>
              <div class="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2"></div>
            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div class="space-y-4">
              <div class="h-6 bg-gray-200 dark:bg-gray-700 rounded w-1/4"></div>
              <div class="space-y-2">
                <div class="h-4 bg-gray-200 dark:bg-gray-700 rounded"></div>
                <div class="h-4 bg-gray-200 dark:bg-gray-700 rounded"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <FooterDefault />
  </div>
</template>

<script setup lang="ts">
const route = useRoute();
const { data: userData, pending } = await useAsyncData("user-profile", () =>
  $fetch(`https://backend.postfeed.in/api/aa-users/${route.params.id}`)
);

useHead({
  title: "Profile | Academic Alerts",
  meta: [
    {
      name: "description",
      content: "View academic profile at Academic Alerts",
    },
  ],
});
</script>
